import Vue from 'vue'

// 引入交建组件库
import {
  Table,
  TableColumn,
  Dialog,
  Menu,
  MenuItem,
  TopNavMenu,
  Scrollbar,
  TimelineApproval,
  Loading,
  Submenu,
  Col,
  CardTitle,
  Row,
  Progress,
  Card,
  Tag,
  DataCard,
  Timeline,
  TimelineItem,
  Button,
  Alert,
  Popover,
  CheckboxGroup,
  Checkbox,
  // Pagination,
  Input,
  Label,
  Breadcrumb,
  BreadcrumbItem,
  HistoryList,
  Form,
  FormItem,
  BottomPrintExport,
  TagSelector,
  Select,
  Option,
  Message,
  Search,
  TopNavMenu2,
  DatePicker,
  InputTagDatePicker,
  DetailInfo,
  Radio,
  RadioButton,
  RadioGroup,
  SimpleFooter,
  Upload,
  FileUpload,
  MultiLevelSelector,
  ServiceSelector,
  Tree,
  TopNavMenu4,
  Cascader,
  BottomGuide,
  EmpFooter,
  Autocomplete,
  Image
} from 'ccui'

import tableList from './common/table-list'

import 'ccui/lib/theme-chalk/index.css' // CCUI样式

import App from './App.vue'
import router from './router'
import store from './store'
import eventBus from '@/utils/msgBus.js'
// import './mock' // mock数据
import './permission' // permission control
import './icons' // SVG
import crypto from './utils/crypto'
import '@/styles/index.scss' // global css
import { addUrlPerFix } from '@/utils/'

import * as filters from './filters'
import Router from 'vue-router' // global filters
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
// 注册全局组件
Vue.prototype.$message = Message
window.$message = Message
Vue.prototype.tableList = tableList
Vue.prototype.$eventBus = eventBus
Vue.prototype.$crypto = crypto
Vue.prototype.$addUrlPerFix = addUrlPerFix
//
Vue.use(Table)
Vue.use(BottomGuide)

Vue.use(TableColumn)
// Vue.use(ElementUI);
Vue.use(EmpFooter)
Vue.use(Tree)
Vue.use(Loading)
Vue.use(CardTitle)
Vue.use(TimelineApproval)
Vue.use(TopNavMenu)
Vue.use(MenuItem)
Vue.use(HistoryList)
Vue.use(Menu)
Vue.use(Scrollbar)
Vue.use(Submenu)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Col)
Vue.use(Row)
Vue.use(Label)
Vue.use(Progress)
Vue.use(Card)
Vue.use(Tag)
Vue.use(BottomPrintExport)
Vue.use(DataCard)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Alert)
Vue.use(Button)
Vue.use(Popover)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Input)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(BottomPrintExport)
Vue.use(TagSelector)
Vue.use(Select)
Vue.use(Option)
Vue.use(Search)
Vue.use(TopNavMenu2)
Vue.use(DatePicker)
Vue.use(InputTagDatePicker)
Vue.use(DetailInfo)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Dialog)
Vue.use(SimpleFooter)
Vue.use(FileUpload)
Vue.use(Cascader)
Vue.use(Upload)
Vue.use(MultiLevelSelector)
Vue.use(ServiceSelector)
Vue.use(TopNavMenu4)
Vue.use(Autocomplete)
Vue.use(Image)
new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
}).$mount('#app')
